import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Guard, Result, UniqueEntityID } from '@digibricks/core';
export var LlmProvider = /*#__PURE__*/function (_Entity) {
  _inherits(LlmProvider, _Entity);

  var _super = _createSuper(LlmProvider);

  function LlmProvider() {
    _classCallCheck(this, LlmProvider);

    return _super.apply(this, arguments);
  }

  _createClass(LlmProvider, [{
    key: "name",
    get: function get() {
      return this.props.name;
    }
  }, {
    key: "baseUrl",
    get: function get() {
      return this.props.baseUrl;
    }
  }, {
    key: "status",
    get: function get() {
      return this.props.status;
    }
  }, {
    key: "models",
    get: function get() {
      return this.props.models;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollections = [{
        argument: props.id,
        argumentName: 'Id'
      }, {
        argument: props.name,
        argumentName: 'Name'
      }, {
        argument: props.baseUrl,
        argumentName: 'BaseUrl'
      }, {
        argument: props.status,
        argumentName: 'Status'
      }, {
        argument: props.models,
        argumentName: 'Models'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        var _guardResult$message;

        return Result.fail((_guardResult$message = guardResult.message) !== null && _guardResult$message !== void 0 ? _guardResult$message : 'Invalid llm provider props');
      }

      if (!Array.isArray(props.models)) {
        return Result.fail('Models must be an array');
      }

      return Result.ok(new LlmProvider(props, new UniqueEntityID(props.id)));
    }
  }]);

  return LlmProvider;
}(Entity);